import React from 'react';
import EditorDeviationLink from '../_partials/DeviationLink';
import { getSizeForFreeform } from '../helpers';
import TierPromotionCardSemiDumb from '../../../DeviationViews/TierPromotionCardEditorDumb';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import { SMALL_MEDIA_WIDTH } from '../constants';
import s from './Tier.scss';
const TierMonoView = (props)=>{
    const containerSize = useEditorContainerSize();
    const { deviation, extOptions, width: propsWidth, link } = props;
    let size;
    size = {
        width: 544,
        height: 295
    };
    // Handle resizing
    size = getSizeForFreeform(size, propsWidth);
    // Restrict to small media
    if (extOptions === null || extOptions === void 0 ? void 0 : extOptions.smallMedia) {
        size = {
            width: SMALL_MEDIA_WIDTH,
            height: 115
        };
    }
    // Make sure its never bigger than the container
    if (containerSize && size.width > containerSize) {
        size = getSizeForFreeform(size, containerSize);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width: size.width
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(TierPromotionCardSemiDumb, {
        width: size.width,
        height: size.height,
        deviation: deviation,
        ctaButton: "subscribe"
    })));
};
TierMonoView.displayName = 'TierMonoView';
export default TierMonoView;

//# sourceMappingURL=Tier.js.map